import { FC } from 'react';
import map from 'lodash/map';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Space from 'antd/lib/space';

import { accountDetailsFields } from 'components/Settings/fieldsConstants';
import { userDataSelector } from 'store/selectors/userSelectors';
import useModal from 'hooks/useModal';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { EModalsNames } from 'modals/constants';

const AccountDetails: FC = () => {
  const { email } = useTypedSelector(userDataSelector);
  const setModal = useModal();

  const handleChangePassword = () => setModal({ modalName: EModalsNames.ChangePassword });

  return (
    <>
      <div>
        <h4>Account Details</h4>
        <Space split={<Divider type="vertical" className="m-0" />} className="mb-4">
          Email {email}
          <Button
            type="link"
            className="text-blue-50 font-regular p-0"
            onClick={handleChangePassword}
          >
            Change Password
          </Button>
        </Space>
      </div>
      <Row gutter={20}>
        {map(accountDetailsFields, ({ component: Component, componentProps, ...itemProps }, key) =>
          <Col span={12} key={key}>
            <Item validateFirst {...itemProps}>
              <Component placeholder={`Enter ${itemProps.label}`} size="large" {...componentProps} />
            </Item>
          </Col>)}
      </Row>
    </>
  );
};

export default AccountDetails;
